import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $filter, $timeout, LocaleService, submissionViewModel, StateUtils, QuoteService, ModalService, MSFMedicalDeductibleLink) {

    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();
    var chosenQuoteId = StateUtils.activeDataForState(true).chosenQuote;

    ctrl.init = function () {
        $scope.submissionVM = submissionVM;
        $scope.MSFMedicalDeductibleLink = MSFMedicalDeductibleLink;
        ctrl.setEmployersLiability();
    };
    $scope.trim = function (description) {
        while (description.charAt(0) === '-') {
            description = description.substr(1);
        }
        return description;
    };
    $scope.medicalDeductibleCoverage = function () {
        var medicalCoverage = null;
        angular.forEach($scope.submissionVM.value.baseData.mSFCoverables_EXT[0].coverages, function (coverage) {
            if (coverage.name === "Medical Deductible") {
                medicalCoverage = coverage;
            }
        });
        return medicalCoverage;
    };
    ctrl.setEmployersLiability = function () {
        angular.forEach($scope.submissionVM.value.baseData.mSFCoverables_EXT[0].coverages, function (coverage) {
            if (coverage.name === "Workers' Compensation Employers Liability Limit Endorsement") {
                $scope.employersLiabilityCoverage = coverage;
            }
        });
        //setting up form field
        $scope.employersLiability = {
            aspects: {
                inputCtrlType: "typelist",
                required: true,
                availableValues: $scope.employersLiabilityCoverage.terms[0].options,
                visible: true,
                get validationMessages() {
                    return ['This is a required field'];
                },
                get valid() {
                    return $scope.employersLiability.value;
                }
            },
            value: $scope.employersLiabilityCoverage.terms[0].chosenTermValue

        };
    };
    $scope.checkForElective = function () {
        $scope.checkElective = false;
        angular.forEach($scope.submissionVM.value.baseData.mSFCoverables_EXT[0].coverages, function (coverage) {
            if (coverage.msfCoverageType_EXT === 'Electable' && coverage.name != 'Medical Deductible') {
                if (coverage.selected === true) {
                    $scope.checkElective = true;
                    return true;
                }
            }
        });
        return $scope.checkElective;
    };

    $scope.updateCoverage = function (coverage) {
        coverage.terms[0].chosenTermValue = $scope.employersLiability.value;
        var action = 'update';
        QuoteService.coverageChange($scope.submissionVM.value, coverage, action).then(function (data) {
            $scope.submissionVM.value = data;
            ctrl.setEmployersLiability();
        }, function () {
            ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
        });
    };
    $scope.updateMedicalDeductible = function (selectedAction) {

        var coverage = $scope.medicalDeductibleCoverage();
        QuoteService.coverageChange($scope.submissionVM.value, coverage, selectedAction).then(function (data) {
            $scope.submissionVM.value = data;
        }, function () {
            ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
        });
    };

    $scope.changeCoverage = function (coverage) {
        var action = 'delete';
        if (coverage.selected === false) action = 'add';

        QuoteService.coverageChange($scope.submissionVM.value, coverage, action).then(function (data) {
            $scope.submissionVM.value = data;
        }, function () {
            ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
        });
    };
    ctrl.next = function (nextFn, form) {
        submissionVM.baseData.mSFIsPolicyCov_EXT.value = true;
        nextFn(submissionVM, form.valid);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$filter', '$timeout', 'LocaleService', 'submissionViewModel', 'StateUtils', 'quoteService', 'ModalService', 'MSFMedicalDeductibleLink'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/controllers/WCPolicyCoveragesCtrl.js
// module id = 1300
// module chunks = 0